const Events = () => {

    return (
        <div>
            
        </div>
    )
};

export default Events;